import { render } from "./Main_enviro.vue?vue&type=template&id=13edd01c"
import script from "./Main_enviro.vue?vue&type=script&lang=js"
export * from "./Main_enviro.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__